import _cloneDeep from 'lodash/cloneDeep';
import Utils from 'services/utils';

/**
 * HelpService class.
 * User this service to handle help configuration and manage help data from API.
 */
export default class HelpService {
    /**
     * @param {RemoteConfigService} RemoteConfigService - Service to get configuration from API/server
     * @constructor
     * @ngInject
     */
    constructor(RemoteConfigService) {
        this.RemoteConfigService = RemoteConfigService;

        this.config = _cloneDeep(this.RemoteConfigService.getServiceConfig('help'));

        this.itemsParsed = {};

        this.parseItems();
    }

    /**
     * Initialize item in map by given url
     * @param {string} url - String url value, will be used as key in map
     */
    initParsedItem(url) {
        if (!(url in this.itemsParsed)) {
            this.itemsParsed[url] = [];
        }
    }

    /**
     * Parse loaded configuration and prepare items map
     */
    parseItems() {
        Object.keys(this.config).forEach((url) => {
            this.initParsedItem(url);

            const items = this.itemsParsed[url];
            const config = this.config[url];

            if (config.items && config.items.length) {
                items.push(...config.items);
            }

            if (config.inherit && config.inherit.length && config.inherit !== url) {
                const inheritUrl = config.inherit;
                const inheritConfig = this.itemsParsed[inheritUrl] || null;

                if (inheritConfig && inheritConfig.length) {
                    items.push(...inheritConfig);
                } else if (this.config[inheritUrl] && this.config[inheritUrl].length) {
                    items.push(...this.config[inheritUrl]);
                }
            }

            this.itemsParsed[url] = Utils.sortItemsByKey(items, 'title');
        });
    }

    /**
     * Get help url by url from the items map
     * @param {string} url - Url value
     * @returns {{}|null} Return help config or null if not absent
     */
    getHelpByUrl(url) {
        return this.itemsParsed[url] || null;
    }

    /**
     * Get all help configs
     * @returns {{}} Return help configs (NOTICE: Parsed and converted to map)
     */
    getAllHelp() {
        return this.itemsParsed;
    }

    /**
     * Get list of all help configs items
     * @returns {Array} Return array of help items
     */
    getHelpList() {
        const items = [];

        Object.keys(this.config).forEach((url) => {
            if (this.config[url].items && this.config[url].items.length) {
                items.push(...this.config[url].items);
            }
        });

        return items;
    }
}



// WEBPACK FOOTER //
// ./app/services/help/help.service.js